import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import { Property } from "./Editor";
import RadioButton from "./RadioButton";
import { css } from "./Theme";

const Boolean = props => {
  return ___EmotionJSX(Property, {
    name: props.name
  }, ___EmotionJSX(RadioButton, {
    name: props.id + "true",
    onChange: e => props.onChange(true),
    checked: props.value == false ? false : true,
    css: css({
      pb: 3
    })
  }, "True"), ___EmotionJSX(RadioButton, {
    name: props.id + "false",
    onChange: e => props.onChange(false),
    checked: props.value == false ? true : false
  }, "False"));
};

export default Boolean;